import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaTwitter, FaFacebookF, FaYoutube, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="fundisha-footer" role="contentinfo">
            <div className="fundisha-marketing-section fundisha-footer-surface">
                <div className="container fundisha-footer-container">
                    <div className="fundisha-footer-brand-block">
                        <Link to="/" className="fundisha-brand fundisha-footer-brand">
                            Fundisha<span className="fundisha-brand-dot">.</span>
                        </Link>
                        <p className="fundisha-footer-intro">
                            A bold learning space for African learners and educators.
                        </p>
                    </div>

                    <div className="fundisha-footer-grid">
                        <section className="fundisha-footer-column">
                            <h4>Quick Links</h4>
                            <nav aria-label="Footer quick links">
                                <ul className="fundisha-footer-list">
                                    <li><Link to="/about" className="fundisha-footer-link">About</Link></li>
                                    <li><Link to="/courses" className="fundisha-footer-link">Courses</Link></li>
                                    <li><Link to="/contact" className="fundisha-footer-link">Contact</Link></li>
                                    <li><Link to="/faq" className="fundisha-footer-link">Help</Link></li>
                                </ul>
                            </nav>
                        </section>

                        <section className="fundisha-footer-column">
                            <h4>Contact</h4>
                            <address className="fundisha-footer-address">
                                <span><FaMapMarkerAlt /> Tom Mboya Street, Nairobi, Kenya</span>
                                <span><FaPhoneAlt /> +254700555823</span>
                                <span><FaEnvelope /> info@fundisha.com</span>
                            </address>
                            <div className="fundisha-footer-socials">
                                <a className="fundisha-social" href="https://twitter.com" aria-label="Twitter"><FaTwitter /></a>
                                <a className="fundisha-social" href="https://facebook.com" aria-label="Facebook"><FaFacebookF /></a>
                                <a className="fundisha-social" href="https://youtube.com" aria-label="YouTube"><FaYoutube /></a>
                                <a className="fundisha-social" href="https://linkedin.com" aria-label="LinkedIn"><FaLinkedinIn /></a>
                            </div>
                        </section>

                        <section className="fundisha-footer-column">
                            <h4>Gallery</h4>
                            <div className="fundisha-footer-gallery">
                                <img className="img-fluid rounded" src="/img/course-1.jpg" alt="Gallery 1" />
                                <img className="img-fluid rounded" src="/img/course-2.jpg" alt="Gallery 2" />
                                <img className="img-fluid rounded" src="/img/course-3.jpg" alt="Gallery 3" />
                            </div>
                        </section>

                        <section className="fundisha-footer-column">
                            <h4>Newsletter</h4>
                            <p className="fundisha-footer-copy">Subscribe for updates and exclusive offers.</p>
                            <form className="fundisha-footer-newsletter" onSubmit={(e) => e.preventDefault()}>
                                <input aria-label="Email" type="email" className="fundisha-input" placeholder="Your email" />
                                <button className="fundisha-btn-primary fundisha-footer-button" type="submit">Sign Up</button>
                            </form>
                        </section>
                    </div>

                    <div className="fundisha-footer-bottom">
                        <div className="fundisha-footer-copy">&copy; <Link to="/" className="fundisha-footer-link">Fundisha</Link> — All Rights Reserved.</div>
                        <div className="fundisha-footer-bottom-links">
                            <Link to="/cookies" className="fundisha-footer-link">Cookies</Link>
                            <Link to="/privacy" className="fundisha-footer-link">Privacy</Link>
                            <Link to="/terms" className="fundisha-footer-link">Terms</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;